import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { useEffect, useRef, useState } from 'react';
import { ChevronDownSVG, ChevronUpSVG } from '@sbercloud/uikit-product-icons';
import { AdaptiveDroplist } from '@sbercloud/uikit-product-mobile-dropdown';
import { ButtonFunction } from '@snack-uikit/button';
import { Tooltip } from '@snack-uikit/tooltip';
import { useCalculatorContext } from '../../../../contexts';
import { PRICE_PERIOD } from '../../../../types/Price';
import { parseKeyToDataTest } from '../../../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var PRICE_NAME = _defineProperty(_defineProperty(_defineProperty({}, PRICE_PERIOD.Month, 'В месяц'), PRICE_PERIOD.Day, 'В день'), PRICE_PERIOD.Hour, 'В час');
export var PRICE_PERIOD_ITEMS = [{
  id: PRICE_PERIOD.Month,
  content: 'В месяц'
}, {
  id: PRICE_PERIOD.Day,
  content: 'В день'
}, {
  id: PRICE_PERIOD.Hour,
  content: 'В час'
}];
export function PricePeriodSelect(_ref) {
  var hasPayaGo = _ref.hasPayaGo;
  var _useCalculatorContext = useCalculatorContext(),
    layoutType = _useCalculatorContext.layoutType,
    pricePeriod = _useCalculatorContext.pricePeriod,
    setPricePeriod = _useCalculatorContext.setPricePeriod;
  var ref = useRef(null);
  var dataTestAttribute = parseKeyToDataTest('price', 'summary-footer-total');
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  useEffect(function () {
    if (hasPayaGo) {
      setPricePeriod(PRICE_PERIOD.Month);
    }
    setOpen(false);
  }, [hasPayaGo, setPricePeriod]);
  return /*#__PURE__*/_jsx(AdaptiveDroplist, {
    layoutType: layoutType,
    size: "m",
    selection: {
      mode: 'single',
      value: pricePeriod,
      onChange: function onChange(v) {
        v && setPricePeriod(v);
        setOpen(false);
      }
    },
    open: hasPayaGo ? false : open,
    onOpenChange: setOpen,
    items: PRICE_PERIOD_ITEMS,
    triggerElemRef: ref,
    "data-test-id": dataTestAttribute,
    children: /*#__PURE__*/_jsx(Tooltip, {
      tip: "\u0414\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u043F\u0435\u0440\u0438\u043E\u0434 \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u043C\u0435\u0441\u044F\u0446, \u0442.\u043A. \u0432 \u0440\u0430\u0441\u0447\u0435\u0442 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u0441\u0435\u0440\u0432\u0438\u0441 \u0441 \u043C\u0435\u0442\u043E\u0434\u043E\u043C \u0442\u0430\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 PAYA (Pay As You Allocate). \u0427\u0442\u043E\u0431\u044B \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0435\u0440\u0438\u043E\u0434 \u0440\u0430\u0441\u0447\u0435\u0442\u0430, \u0443\u0434\u0430\u043B\u0438\u0442\u0435 PAYA-\u0441\u0435\u0440\u0432\u0438\u0441 \u0438\u0437 \u0440\u0430\u0441\u0447\u0435\u0442\u0430",
      open: hasPayaGo ? undefined : false,
      children: /*#__PURE__*/_jsx(ButtonFunction, {
        ref: ref,
        onClick: hasPayaGo ? function (e) {
          return e.stopPropagation();
        } : function () {
          return setOpen(function (v) {
            return !v;
          });
        },
        label: PRICE_NAME[pricePeriod],
        size: "m",
        icon: open && !hasPayaGo ? /*#__PURE__*/_jsx(ChevronUpSVG, {}) : /*#__PURE__*/_jsx(ChevronDownSVG, {}),
        disabled: hasPayaGo
      })
    })
  });
}